import { ApiHttpService } from '../../services';

export const InTransitDocumentModule = {
    namespaced: true,
    actions: {
        async listDocuments(context, payload) {
            const response = await ApiHttpService.getRequest('in-transit-documents', payload);
            return response.data;
        },
        async getDocument(context, { docEntry, type, connection }) {
            const response = await ApiHttpService.getRequest('in-transit-documents/' + encodeURIComponent(docEntry), { type, connection });
            return response.data;
        }
    }
};
